module.exports = require('./helpers/bundle-url').getBundleURL('licOR') + "logo-dark.eefe0b7f.svg";